import { LOCALSTORAGE_HOUSEHOLD_SIZE } from '@constants/localStorage';
import { useAuthentication } from '@context/businessContainer';
import { useLocalStorage } from '@monofront/business/hooks';
import { userService } from '@services/businessContainer';
import { isNumber } from 'radash';
import { useEffect } from 'react';
import logger from '@utils/logger';

export const useHouseholdSize = () => {
  const [size, setSize] = useLocalStorage<number | undefined>(
    LOCALSTORAGE_HOUSEHOLD_SIZE,
    undefined,
  );

  return { size: size ?? 1, setSize };
};

/**
 * Syncs localStorage household size to customer database when the user is authenticated.
 */
export const useHouseholdSizeDBSync = () => {
  const { customer } = useAuthentication();
  const [size] = useLocalStorage<number | undefined>(
    LOCALSTORAGE_HOUSEHOLD_SIZE,
    undefined,
  );

  useEffect(() => {
    if (!isNumber(size) || !customer?.uid || size === customer?.householdSize)
      return;

    const sync = async () => {
      try {
        await userService.updateHouseholdSize(size, customer.uid);
      } catch (error) {
        logger.error('Failed to sync household size to backend', error);
      }
    };

    void sync();
  }, [customer, size]);
};
